import Vue from "vue"
import Tabs from "vue-tabs-component"

Vue.use(Tabs)
